<template>
  <div class="pagination__wrapper">
    <div
      v-if="totalRow"
      class="pagination__total-rows">
      Total: {{ objPagination.count || 0 }}
    </div>
    <v-select
      v-model="dataSelectValuePagination"
      :options="dataSelectOptionsPagePagination"
      :searchable="false"
      :clearable="false"
      class="call-select call-select_pc"
      @input="data => clickDownUpPage('select', data)">
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <font-awesome-icon :icon="dataIconDown" />
        </span>
      </template>
    </v-select>
    <b-pagination
      :key="computedPage.data.page"
      :class="[disabledWhileLoading && 'disabled-while-loading']"
      :value="computedPage.data.page"
      :total-rows="computedPage.data.count"
      :per-page="computedPage.data.limit"
      last-number
      first-number
      limit="5"
      @change="changePage" />
    <!-- </template> -->
  </div>
</template>

<script>
import { BPagination } from 'bootstrap-vue';
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faTimes
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import helper, { tabelCell } from '../../service/helper';

import debounce from 'lodash/debounce';

export default {
  name: 'CallPagination',
  components: { BPagination },
  props: {
    totalRow: {
      type: Boolean,
      default: false
    },
    objPagination: {
      type: Object,
      default: () => ({})
    },
    pageInit: {
      type: Number,
      default: null
    },
    pageValue: {
      type: Number,
      default: null
    },
    pageCalc: {
      type: Boolean,
      default: false
    },
    disabledWhileLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataRowLeft: faChevronLeft,
      dataRowRight: faChevronRight,
      dataIconDown: faChevronDown,
      dataComponentDeselect: {
        render: createElement =>
          createElement(FontAwesomeIcon, {
            props: {
              icon: faTimes
            }
          })
      },
      dataSelectValuePagination: 50,
      dataSelectOptionsPagePagination: [30, 50, 100]
    };
  },
  computed: {
    computedDisabledDownBtn () {
      const { page = 0 } = this.objPagination;
      if (page === 0) {
        return true;
      }
      return false;
    },
    computedDisabledUpBtn () {
      const { page = 0, limit = 0, count = 0 } = this.objPagination;
      if ((page + 1) * limit >= count) {
        return true;
      }
      return false;
    },

    computedPage () {
      return {
        text: this.objPagination?.count ? `${this.objPagination.page + 1} / ${Math.ceil(
          this.objPagination.count / this.objPagination.limit
        )}` : '1 / 1',
        data: {
          page: this.objPagination?.count ? this.objPagination.page + 1 : 1,
          limit: this.objPagination.limit || 0,
          count: this.objPagination?.count ? this.objPagination.count : 0
        }
      };
    }
  },

  created () {
    const tabelCellLen = this.pageValue
      ? this.pageValue
      : tabelCell(this.pageInit);

    if (
      !this.dataSelectOptionsPagePagination.some(item => item === tabelCellLen)
    ) {
      this.dataSelectOptionsPagePagination.push(tabelCellLen);
      this.dataSelectOptionsPagePagination.sort((a, b) => a - b);
    }

    this.dataSelectValuePagination = tabelCellLen;

    const { currentRoute: { name: pageName } = {} } = this.$router;

    const _filterKey = `_filter${pageName}`;

    if (!helper.isEmpty(this.$route.query, _filterKey)) {
      try {
        const options = helper.clearObject(
          JSON.parse(this.$route.query[_filterKey])
        );

        const _arrFilter = ['limit', 'page'];

        for (const _key of _arrFilter) {
          if (!helper.isEmpty(options, _key)) {
            switch (_key) {
              case 'limit':
                this.dataSelectValuePagination = options[_key];
                break;
              case 'page':
                // eslint-disable-next-line vue/no-mutating-props
                this.objPagination.page = options[_key];
                break;
            }
          }
        }
      } catch (e) {
        console.log('Error query params pagination');
      }
    }
  },
  methods: {
    changePage: debounce(function (currentPage) {
      this.$emit('on-pagination', {
        page: currentPage - 1,
        limit: this.dataSelectValuePagination
      });
    }, 100),

    clickDownUpPage (value, data) {
      const { page = 0 } = this.objPagination;
      switch (value) {
        case 'down':
          if (page <= 0) {
            return;
          }
          this.$emit('on-pagination', {
            page: page - 1,
            limit: this.dataSelectValuePagination
          });
          break;
        case 'up':
          this.$emit('on-pagination', {
            page: page + 1,
            limit: this.dataSelectValuePagination
          });
          break;
        case 'select':
          this.$emit('on-pagination', {
            page: 0,
            limit: data
          });
          break;
      }
    }
  }
};
</script>
